export const environment = {
  production: true,
  API_URL: 'https://rkh-api.jobatory.com/api',
  API_DOMAIN: 'rkh-api.jobatory.com',
  CLIENT_FRONT_URL: 'https://rkh.jobatory.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAqOKic2vp-CPv-77i2dHEmUkWKJObf2c0',
  JIRA_WIDGET_DATA_KEY: '8ef68994-64b6-4900-9e32-d2ce4c1c61c8',
};
